import store from '..'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

export default {
  namespaced: true,
  state () {
    return {
      user: null,
      data: null,
      reference: null,
      shutdown: false,
      initial: false
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    data (state) {
      return state.data
    },
    reference (state) {
      return state.reference
    },
    shutdown (state) {
      return state.shutdown
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state) {
      state.user = null
      state.data = null
    },
    setUser (state, payload) {
      state.user = JSON.parse(JSON.stringify(payload))
    },
    setData (state, payload) {
      state.data = JSON.parse(JSON.stringify(payload))
    },
    add (state, payload) {
      state.data = payload
    },
    update (state, payload) {
      state.data = payload
    },
    remove (state, payload) {
      state.data = null
    },
    reference (state, payload) {
      state.reference = payload
    },
    setShutdown (state, payload) {
      state.shutdown = payload
    },
    setInitial (state, payload) {
      state.initial = payload
    }
  },
  actions: {
    init ({ commit }) {
      commit('init')
    },
    signUserUp ({ commit }, payload) {
      return new Promise((resolve) => {
        store.dispatch('shared/setLoading', true)
        store.dispatch('shared/setError', null)
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
          .then(
            data => {
              store.dispatch('shared/setLoading', false)
              firebase.auth().currentUser.sendEmailVerification().then(function () {
                store.dispatch('shared/setError', new Error('入力されたメールアドレス宛にメールを送信しました。内容をご確認ください。'))
                store.dispatch('auth/release', null)
                resolve(null)
              }).catch(function (error) {
                store.dispatch('shared/setError', new Error('メールの送信に失敗しました。'))
                resolve(error)
              })
            }
          )
          .catch(
            error => {
              // console.log(error)
              store.dispatch('shared/setLoading', false)
              store.dispatch('shared/setError', error)
              resolve(error)
            }
          )
      })
    },
    signUserIn ({ commit }, payload) {
      return new Promise((resolve) => {
        store.dispatch('shared/setLoading', true)
        store.dispatch('shared/setError', null)
        firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
          .then(
            data => {
              store.dispatch('shared/setLoading', false)
              if (!data.user.emailVerified) {
                store.dispatch('auth/release', null)
                var error = new Error('メールアドレスの確認が終わっていません。本サービスから受信したメールをご確認ください。')
                store.dispatch('shared/setError', error)
                resolve(error)
              }
            }
          )
          .catch(
            error => {
              if (error.code === 'auth/user-not-found') {
                store.dispatch('shared/setError', new Error('入力されたメールアドレスが登録されていません。再度ご確認ください。'))
              } else if (error.code === 'auth/wrong-password') {
                store.dispatch('shared/setError', new Error('入力されたパスワードが一致しません。再度ご確認ください。'))
              } else {
                store.dispatch('shared/setError', error)
              }
              store.dispatch('shared/setLoading', false)
              resolve(error)
            }
          )
      })
    },
    subscribe ({ commit }) {
      return new Promise((resolve, reject) => {
        const db = firebase.firestore()
        var user = store.getters['auth/user']
        var dbRef = db.collection('users')
        var reference = dbRef.where('key', '==', user.uid).onSnapshot(snapshots => {
          if (snapshots.empty) {
            resolve()
          }
          snapshots.docChanges().forEach(change => {
            var data = JSON.parse(JSON.stringify(change.doc.data()))
            if (change.type === 'added') {
              commit('add', data)
            } else if (change.type === 'modified') {
              commit('update', data)
            } else if (change.type === 'removed') {
              commit('remove', data)
            }
          })
          resolve()
        })
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['auth/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('remove', null)
          resolve()
        } else {
          resolve()
        }
      })
    },
    checkID ({ commit }, payload) {
      return new Promise((resolve) => {
        store.dispatch('shared/setLoading', true)
        store.dispatch('shared/setError', null)
        const functions = firebase.app().functions('asia-northeast1')
        const checkId = functions.httpsCallable('checkId')
        checkId(payload).then(function (result) {
          store.dispatch('shared/setLoading', false)
          if (result.data === null) {
            var error = new Error('利用者登録IDが無効です')
            store.dispatch('shared/setError', error)
          }
          store.dispatch('shared/setSchool', result.data).then(() => {
            resolve(result.data)
          })
        })
      })
    },
    getUser ({ commit }, payload) {
      return new Promise((resolve) => {
        const functions = firebase.app().functions('asia-northeast1')
        const getUser = functions.httpsCallable('getUser')
        getUser(payload).then(function (result) {
          commit('setUser', payload)
          if (result.data) {
            if (result.data.role === 'admin') {
              var p = 'owner'
              if (result.data.root) {
                p = 'admin'
              }
              store.dispatch('shared/setPrivilege', p)
            }
          }
          resolve(result.data)
        })
      })
    },
    readUser ({ commit }, payload) {
      return new Promise((resolve) => {
        const functions = firebase.app().functions('asia-northeast1')
        const getUser = functions.httpsCallable('getUser')
        getUser(payload).then(function (result) {
          resolve(result.data)
        })
      })
    },
    googleLogIn ({ commit }, payload) {
      return new Promise((resolve) => {
        store.dispatch('shared/setLoading', true)
        store.dispatch('shared/setError', null)
        var provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider)
          .then(
            data => {
              store.dispatch('shared/setLoading', false)
              resolve()
            }
          )
          .catch(
            error => {
              store.dispatch('shared/setLoading', false)
              store.dispatch('shared/setError', error)
              resolve(error)
            }
          )
      })
    },
    setShutdown ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('setShutdown', payload)
        resolve()
      })
    },
    setInitial ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('setInitial', payload)
        resolve()
      })
    },
    get ({ commit }, payload) {
      return new Promise(async (resolve) => {
        // var startTime = Date.now()
        if (store.getters['auth/initial']) {
          resolve()
          return
        }
        var data = store.getters['auth/data']
        await store.dispatch('auth/setInitial', false)
        await store.dispatch('shared/setLoading', true)
        if (data && data.docs) {
          await store.dispatch('users/subscribe')
        } else {
          await store.dispatch('users/subscribe', payload)
        }
        await store.dispatch('groups/subscribe', payload)
        if (data && data.docs) {
          await store.dispatch('schools/subscribe')
        } else {
          await store.dispatch('schools/subscribe', payload)
        }
        if (payload) {
          await store.dispatch('chatRef/subscribe', payload)
          await store.dispatch('chatRefStatus/subscribe', payload)
          await store.dispatch('chatUnread/subscribe', payload)
          await store.dispatch('metricsActs/subscribe', payload)
          await store.dispatch('metricsPlans/subscribe', payload)
          await store.dispatch('metricsStatus/subscribe', payload)
          await store.dispatch('metricsRevises/subscribe', payload)
          await store.dispatch('metricsFees/subscribe', payload)
          await store.dispatch('templateEvents/subscribe', payload)
          await store.dispatch('templateTasks/subscribe', payload)
          await store.dispatch('scheduleEvents/subscribe', payload)
          await store.dispatch('scheduleTasks/subscribe', payload)
        }
        await store.dispatch('locations/subscribe', payload)
        await store.dispatch('holidays/subscribe')
        await store.dispatch('notices/subscribe')
        await store.dispatch('publicUsers/subscribe')
        await store.dispatch('publicGroups/subscribe')
        await store.dispatch('shares/subscribe')
        await store.dispatch('sharesPublics/subscribe')
        await store.dispatch('sharesStatics/subscribe')
        await store.dispatch('students/subscribe', payload)
        await store.dispatch('scholae/subscribe', payload)
        await store.dispatch('tags/subscribe', payload)
        await store.dispatch('statuses/subscribe')

        await store.dispatch('shared/setLoading', false)
        await store.dispatch('auth/setInitial', true)
        // var endTime = Date.now()
        // console.log('auth/get completed!', endTime - startTime)
        resolve()
      })
    },
    release ({ commit }) {
      return new Promise(async (resolve) => {
        if (store.getters['auth/shutdown']) {
          resolve()
          return
        }
        await store.dispatch('auth/setShutdown', true)
        await store.dispatch('statuses/unSubscribe')
        await store.dispatch('tags/unSubscribe')
        await store.dispatch('metricsFees/unSubscribe')
        await store.dispatch('metricsRevises/unSubscribe')
        await store.dispatch('metricsStatus/unSubscribe')
        await store.dispatch('metricsPlans/unSubscribe')
        await store.dispatch('metricsActs/unSubscribe')
        await store.dispatch('scholae/unSubscribe')
        await store.dispatch('students/unSubscribe')
        await store.dispatch('sharesStatics/unSubscribe')
        await store.dispatch('sharesPublics/unSubscribe')
        await store.dispatch('shares/unSubscribe')
        await store.dispatch('publicGroups/unSubscribe')
        await store.dispatch('publicUsers/unSubscribe')
        await store.dispatch('chatUnread/unSubscribe')
        await store.dispatch('chatRefStatus/unSubscribe')
        await store.dispatch('notices/unSubscribe')
        await store.dispatch('scheduleTasks/unSubscribe')
        await store.dispatch('scheduleEvents/unSubscribe')
        await store.dispatch('templateTasks/unSubscribe')
        await store.dispatch('templateEvents/unSubscribe')
        await store.dispatch('holidays/unSubscribe')
        await store.dispatch('locations/unSubscribe')
        await store.dispatch('chatMessage/unSubscribe')
        await store.dispatch('chatRef/unSubscribe')
        await store.dispatch('schools/unSubscribe')
        await store.dispatch('groups/unSubscribe')
        await store.dispatch('users/unSubscribe')
        await store.dispatch('auth/unSubscribe')
        await firebase.auth().signOut()
        await commit('init')
        await store.dispatch('auth/setInitial', false)
        await store.dispatch('auth/setShutdown', false)
        resolve()
      })
    }
  }
}
